import { DataGridTypes } from 'devextreme-react/cjs/data-grid'
import { Form as DXForm, GroupItem, Tab, TabbedItem, TabPanelOptions } from 'devextreme-react/form'
import type { ad_quote } from '@/model/qsadminapi/QsAdminApiModuleModel'
import QuoteHistory from '@/routes/quotes/QuoteHistory'
import QuoteSubscriptions from '@/routes/quotes/QuoteSubscriptions'
import { useScreenSize } from '@/themes/media-query'

export function QuoteBriefDetail(props: DataGridTypes.MasterDetailTemplateData) {
  const quote: ad_quote = props.data.data
  const currentScreenSize = useScreenSize()

  return (
    <>
      <div className={'dx-card responsive-paddings'}>
        <DXForm id={'quote_brief_detail_form'} formData={quote} labelLocation={'top'} readOnly={true}>
          <GroupItem colCount={5} colSpan={5}>
            <GroupItem colCount={1} colSpan={5}>
              <TabbedItem>
                <TabPanelOptions
                  animationEnabled={true}
                  swipeEnabled={currentScreenSize.isSmall || currentScreenSize.isXSmall}
                  deferRendering={false}
                  scrollingEnabled={true}
                />
                <Tab title="STORICO">
                  <QuoteHistory quote={quote}></QuoteHistory>
                </Tab>
                <Tab title="SUBSCRIPTION">
                  <QuoteSubscriptions quote={quote}></QuoteSubscriptions>
                </Tab>
              </TabbedItem>
            </GroupItem>
          </GroupItem>
        </DXForm>
      </div>
    </>
  )
}
